import { render, staticRenderFns } from "./SectionNews.vue?vue&type=template&id=7bc00d5e&scoped=true&"
import script from "./SectionNews.vue?vue&type=script&lang=js&"
export * from "./SectionNews.vue?vue&type=script&lang=js&"
import style0 from "./SectionNews.vue?vue&type=style&index=0&id=7bc00d5e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc00d5e",
  null
  
)

export default component.exports